import {SessionManager, SessionType} from './session-management/session-manager';

export const isNorskJeger = () => SessionManager.sessionType === SessionType.OIDC;

export const isNorskJegerByType = (sessionType) => sessionType === SessionType.OIDC;

export const isUtenlandskJegerByType = (sessionType) => sessionType === SessionType.BASIC_AUTH;
